export default "__VITE_ASSET__C9akdg2Q__"